<template>
  <div class="relative ml-[50%] h-full w-full text-center">
    <p class="absolute bottom-0 w-full">
      <span><slot /></span><br />
    </p>
  </div>
</template>
